// src/components/modals/InviteModal.jsx
import React, { useState, useEffect } from 'react';
import Modal from '../common/Modal';
import ChatAvatar from '../ChatAvatar';
import { getDisplayName } from '../../utils/userHelpers';
import './InviteModal.css';

const InviteModal = ({
    isOpen,
    onClose,
    group,                       // { chat_id, title }    
    api,
    onInvite,                    // (userIds) => Promise
}) => {
    const [users, setUsers] = useState([]);
    const [selectedIds, setSelectedIds] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingUsers, setLoadingUsers] = useState(false);

useEffect(() => {
    if (!isOpen || !group) return;
    
    setSelectedIds([]);
    
    const loadUsers = async () => {
        setLoadingUsers(true);
        try {
            const groupId = group.chat_id.replace('group_', '');
            const response = await api.get(`/groups/candidates?group_id=${groupId}`);
            setUsers(response.data || []);
        } catch (error) {
            console.error('Failed to load candidates:', error);
            setUsers([]);
        } finally {
            setLoadingUsers(false);
        }
    };
    
    loadUsers();
}, [isOpen, group, api]);

    const toggleUser = (userId) => {
        if (selectedIds.includes(userId)) {
            setSelectedIds(selectedIds.filter(id => id !== userId));
        } else {
            setSelectedIds([...selectedIds, userId]);
        }
    };

    const handleInvite = async () => {
        if (selectedIds.length === 0) return;

        setLoading(true);
        try {
            await onInvite(selectedIds);
            onClose();
        } catch (error) {
            console.error('Failed to invite:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title="Пригласить в группу"
            icon="bi bi-person-plus"
            size="medium"
            footer={
                <>
                    <button className="btn-cancel" onClick={onClose}>Отмена</button>
                    <button 
                        className="btn-save" 
                        onClick={handleInvite}
                        disabled={loading || selectedIds.length === 0}
                    >
                        {loading ? 'Отправка...' : `Пригласить (${selectedIds.length})`}
                    </button>
                </>
            }
        >
            <div className="invite-group-name">
                <i className="bi bi-people-fill"></i> {group?.title}
            </div>

            <div className="selected-count">
                Выбрано: {selectedIds.length}
            </div>

            {loadingUsers ? (
                <div className="loading">Загрузка пользователей...</div>
            ) : users.length === 0 ? (
                <div className="no-users">Нет пользователей для приглашения</div>
            ) : (
                <div className="users-list">
                    {users.map(user => (
                        <div 
                            key={user.id} 
                            className={`user-item ${selectedIds.includes(user.id) ? 'selected' : ''}`}
                            onClick={() => toggleUser(user.id)}
                        >
                             <ChatAvatar chat={{
                                            avatar: user?.avatar_url,
                                            title:  user.display_name || user.username || 'User',
                                            chat_id: user?.id || 0,
                                            }} 
                                className="user-avatar"
                                imgClassName="avatar-img"
                                placeholderClassName="avatar-placeholder-small"
                            /> 
                            <div className="user-info-list">
                                <div className="user-name-list">
                                    {user.display_name || getDisplayName(user)}
                                </div>
                                <div className="user-details-list">
                                    {user.phone && <span><i className="bi bi-phone"></i> {user.phone}</span>}
                                    {user.email && <span><i className="bi bi-envelope"></i> {user.email}</span>}
                                </div>
                            </div>
                            <div className="user-checkbox">
                                <i className={selectedIds.includes(user.id) ? 'bi bi-check-circle-fill' : 'bi bi-circle'}></i>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </Modal>
    );
};

export default InviteModal;